import React from 'react';
import CategoryPage from 'app/components/CategoryPage/CategoryPage';

const Index = () => {
    return <CategoryPage></CategoryPage>;
};

export default Index;
